// Vendor
import vhCheck from "vh-check";
vhCheck();

import "./modules/lazyloading";

// Sections
import "./sections/header";
import "./sections/marquee";
import "./sections/product";
import "./sections/main-article";
import "./sections/section-ingredients";
import "./sections/section-ingredient-details";
import "./sections/collections-shopthelook";
import "./sections/section-video-lightbox";

// Snippets
import "./snippets/badges";
import "./snippets/card-blog";

// Cart
import "./sections/cart";
// import "./sections/SmartCart";

// Import utils to Window
import { utils } from "./modules/utils";
window.utils = utils;

// Alpine
import "./alpine/main";

// import {
//   setLocalization,
//   initLocalizationForm,
// } from "./snippets/set-localization";
// setLocalization();
// initLocalizationForm();
